import { render, staticRenderFns } from "./ContactPersonPicker.vue?vue&type=template&id=48d3ab5c"
import script from "./ContactPersonPicker.vue?vue&type=script&lang=ts"
export * from "./ContactPersonPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports